module.exports = __webpack_public_path__ + "static/media/tap_07_img03.457489d7.png";